import React from 'react';

const Dashboard: React.FC = () => {
    return (
        <div>
            Welcome to the Home Page!
        </div>
    );
};

export default Dashboard;